module.exports = __webpack_public_path__ + "img/img-1.17ad4f1f.gif";